import { Usuario } from "./Usuario.ts";

export class Empresa {
  id: number;
  nome: string;
  email: string;
  cnpj: string;
  usuarios: Usuario[];

  constructor(dados: any) {
    this.id = dados.id;
    this.nome = dados.nome;
    this.email = dados.email;
    this.cnpj = dados.cnpj;
    this.usuarios = dados.usuarios ? dados.usuarios.map((user: any) => new Usuario(user)) : [];
  }
}
